import { render, staticRenderFns } from "./File.vue?vue&type=template&id=122a46bf&scoped=true"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"
import style0 from "./File.vue?vue&type=style&index=0&id=122a46bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a46bf",
  null
  
)

export default component.exports